import React, { useContext, useState } from "react";
import { FaArrowLeft, FaTimes, FaSortAlphaDown } from "react-icons/fa";
import "../../styles/components-styles/sidebar-styles/ExtendedTextbookSidebar.css";
import { SidebarContext } from "../../contexts/SidebarContext";

function ExtendedTextbookSidebar() {
    const { toggleExtendedTextbookSidebar, showExtendedTextbookSidebar } = useContext(SidebarContext);
    const [selectedWord, setSelectedWord] = useState(null);

    const words = ["Anatomy", "Biochemistry", "Cardiology", "Dermatology", "Endocrinology", "Gastroenterology", "Hematology", "Immunology", "Neurology", "Oncology"];
    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    
    const selectWord = (word) => setSelectedWord(word);
    
    return (
        <div className={`extended-textbook-sidebar ${showExtendedTextbookSidebar ? "open" : "closed"}`}>
            <div className="extended-textbook-sidebar-header">
                <FaArrowLeft className="icon" onClick={() => setSelectedWord(null)} title="Back" />
                <input type="text" placeholder="Search..." className="extended-textbook-sidebar-search" />
                <div className="extended-textbook-sort-box">
                    AZ <FaSortAlphaDown />
                </div>
                <FaTimes 
                    className="extended-textbook-close-icon" 
                    onClick={() => {
                        toggleExtendedTextbookSidebar()
                    }} 
                    title="Close" 
                />
            </div>

            {!selectedWord ? (
                <>
                    <h3 className="extended-textbook-sidebar-title">Index</h3>
                    <div className="extended-textbook-sidebar-content">
                        <div className="extended-textbook-word-container">
                            {words.map((word, index) => (
                                <div key={index} className="extended-textbook-word-box" onClick={() => selectWord(word)}>
                                    {word}
                                </div>
                            ))}
                        </div>
                        <div className="extended-textbook-alphabet-container">
                            {alphabet.map((letter, index) => (
                                <div key={index} className="extended-textbook-alphabet-box">{letter}</div>
                            ))}
                        </div>
                    </div>
                </>
            ) : (
                <div className="extended-textbook-word-list">
                    <h3 className="extended-textbook-list-title">{selectedWord}</h3>
                    <ul>
                        <li className="extended-textbook-list-item">Definition of {selectedWord}</li>
                        <li className="extended-textbook-list-item">Uses of {selectedWord}</li>
                        <li className="extended-textbook-list-item">Related topics to {selectedWord}</li>
                    </ul>
                </div>
            )}
        </div>
    );
}

export default ExtendedTextbookSidebar;
